<template>
<div>
    <navbar></navbar>
	<div class="row" id="body-row" style="background-color: #ffffff;">
    <slot />
    <!-- Main Col END -->
	</div>
</div>
</template>
<script>
// import '@/assets/css/content-layout/js/c1b864fb23.js'
import navbar from '@/components/layout/Navbar'
export default {
	name: 'Print',
	components: {
		navbar
	},
	mounted () {
		const plugin = document.createElement('script')
		plugin.setAttribute(
			'src',
			'https://kit.fontawesome.com/c1b864fb23.js'
		)
		document.head.appendChild(plugin)
	},
	computed: {
	}
}

</script>
<style>
#content-body {
  background-image: none;
  background-color: #ffffff;
  color:black;
}
</style>



// WEBPACK FOOTER //
// src/components/Print.vue